var _path, _path2, _path3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg001(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0835 2.427C11.3231 2.427 9.896 3.85409 9.896 5.6145V7.03117C9.896 7.61797 9.4203 8.09367 8.8335 8.09367C8.24669 8.09367 7.771 7.61797 7.771 7.03117V5.6145C7.771 2.68049 10.1495 0.302002 13.0835 0.302002H15.9168C18.8508 0.302002 21.2293 2.68049 21.2293 5.6145V7.03117C21.2293 7.61797 20.7536 8.09367 20.1668 8.09367C19.58 8.09367 19.1043 7.61797 19.1043 7.03117V5.6145C19.1043 3.85409 17.6772 2.427 15.9168 2.427H13.0835Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99992 7.03125H22.9999C26.1295 7.03125 28.6666 9.5683 28.6666 12.6979C28.6666 12.6979 25.3138 15.979 16.8074 16.3136C16.7015 16.3177 16.6095 16.2377 16.5905 16.1334C16.4102 15.1426 15.5428 14.3913 14.4999 14.3913C13.4872 14.3913 12.6399 15.0997 12.4267 16.0481C12.4035 16.1512 12.3089 16.2272 12.2035 16.2193C3.6806 15.5806 0.333252 12.6979 0.333252 12.6979C0.333252 9.5683 2.87031 7.03125 5.99992 7.03125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3749 18.1215C12.3749 18.0165 12.2919 17.9293 12.1872 17.9215C5.49496 17.4252 1.75669 15.6672 0.333252 14.8408V24.0313C0.333252 27.1609 2.8703 29.6979 5.99992 29.6979H22.9999C26.1295 29.6979 28.6666 27.1609 28.6666 24.0313V14.8999C27.2398 15.8349 23.4923 17.7932 16.8195 18.0697C16.7119 18.0742 16.6249 18.1625 16.6249 18.2701V18.4996C16.6249 19.6732 15.6735 20.6246 14.4999 20.6246C13.3263 20.6246 12.3749 19.6732 12.3749 18.4996V18.1215Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.4375,
    y: 15.5312,
    width: 2.125,
    height: 3.9582,
    rx: 1.0625,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg001);
export default __webpack_public_path__ + "static/media/001.943081d059bcbd5b6fbe3577cf43ceb5.svg";
export { ForwardRef as ReactComponent };